import {useEffect, useState} from 'react';

import {getSupportedSsoAuditActions} from 'src/openapi/admin/apis/DictionaryApi';
import {useAppDispatch} from 'src/store/hooks';

type UseSupportedAuditActionsReturn = {
    actionOptions: DicItem[],
    getTitleById: (id: string) => string | undefined,
};

export type DicItem = {
    id: string,
    title: string,
};

export function useSupportedSsoActions(): UseSupportedAuditActionsReturn {
    const dispatch = useAppDispatch();
    const [actionOptions, setActionOptions] = useState<DicItem[]>([]);

    useEffect(() => {
        const controller = new AbortController();

        (async () => {
            try {
                const response = await dispatch(
                    getSupportedSsoAuditActions({signal: controller.signal}),
                );
                if (controller.signal.aborted) {
                    return;
                }
                if (response.payload?.success) {
                    setActionOptions(
                        response.payload.data
                            .flatMap(item => item.children ?? [])
                            .map(opt => ({id: opt.id, title: opt.description ?? opt.id})),
                    );
                }
            } catch {
                // non-critical — filter just won't have options
            }
        })();

        return () => {
            controller.abort();
        };
    }, [dispatch]);

    const getTitleById = (id: string): string | undefined =>
        actionOptions.find(item => item.id === id)?.title;

    return {actionOptions, getTitleById};
}
